module.exports = __webpack_public_path__ + "img/BULB_120X35.77c55c40.png";